<template>
  <div>
    <template v-if="loaded">
      <report-item type="language" title="Language pairs" />
      <report-item type="industry" title="Industry sectors" />
      <report-item type="document" title="Document types" />
      <report-item type="qa" title="QA models" />
      <report-item type="evaluation" title="Evaluation methods" />
    </template>
    <preload-block :preloaderStatus="true" v-else></preload-block>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  components: {
    'report-item': () => import('../resultsItem/index.vue'),
    'preload-block': () => import('@/components/preloader/index.vue'),
  },
  data: () => ({
    loaded: false,
  }),
  created () {
    return Promise.all([
      this.$store.dispatch('GET_LANGUAGES'),
      this.$store.dispatch('GET_INDUSTRY'),
      this.$store.dispatch('GET_COUNTRIES'),
      this.$store.dispatch('GET_DOCUMENT_TYPES'),
      this.$store.dispatch('GET_QA_METHODS'),
    ]).finally(() => {
      this.loaded = true;
    });
  },
  beforeRouteLeave(to, from, next) {
    this.loaded = false;
    this.$nextTick(() => {
      next();
    });
  },
});
</script>

<style lang="scss">
</style>
